<template>
	<div v-loading="loading" class="base_scroll_page" style="padding: 15px 15px 15px 200px;">
		<!-- 区域选择 -->
		<AreaChoise @nodeClick="handleAreaChoiseSelect"></AreaChoise>
		<!-- 区域选择 end -->
		
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="hospitaler_name" class="b_inp" placeholder="姓名"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">手机号码：</span>
					<el-input v-model="hospitaler_phone" class="b_inp" placeholder="手机号码"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">所属医院：</span>
					<el-input v-model="hospitaler_firm" class="b_inp" placeholder="所属医院"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">创建人：</span>
					<el-input v-model="hospitaler_creater" class="b_inp" placeholder="创建人"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="hospitaler_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="hospitaler_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
				<el-button type="primary" @click="handleAddHospitalerClick">新增医院管理者</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="phone"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="firmName"
						label="所属医院"
					>
					</el-table-column>
					<el-table-column
						prop="creater"
						label="创建人"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewHospitalerClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleResetPasswordClick(scope.row)"
							>重置密码</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 主体区域 end -->
		
		<!-- 新增医院管理者弹出框 -->
		<Popup
			v-model="addHospitaler_popup_display"
			title="新增医院管理者"
			confirmBtnText="添加"
			@confirmClick="handleAddHospitalerPopupConfirmClick"
		>
			<div v-loading="add_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
					<el-input v-model="addHospitaler_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerName_tip"><i class="b_icon"></i>请输入姓名</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
					<el-input v-model="addHospitaler_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>擅长</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="addHospitaler_special">
							<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerSpecial_tip"><i class="b_icon"></i>至少勾选一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属医院</span>
					<VDistpicker @province="handleAddHospitalerAddrProvinceSelect" @city="handleAddHospitalerAddrCitySelect" @area="handleAddHospitalerAddrAreaSelect"></VDistpicker>
					<div class="base_tip"><template v-if="addHospitalerAddr_tip"><i class="b_icon"></i>请选择区域</template></div>
					<el-select v-model="addHospitaler_firm" placeholder="请先选择区域" style="width: 200px;">
						<el-option v-for="v in addHospitaler_firms" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addHospitalerFirm_tip"><i class="b_icon"></i>请选择所属医院</template></div>
			</div>
		</Popup>
		<!-- 新增医院管理者弹出框 end -->
		
		<!-- 查看医院管理者弹出框 -->
		<Popup 
			v-model="viewHospitaler_popup_display"
			title="医院管理者详情"
			confirmBtnText="修改"
			@confirmClick="handleUpdateHospitalerClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label">姓名</span>
					<el-input :value="viewHospitaler_name" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">账号</span>
					<el-input :value="viewHospitaler_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">手机号</span>
					<el-input :value="viewHospitaler_phone" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">所属医院</span>
					<el-input :value="viewHospitaler_firm" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">身份</span>
					<el-input :value="viewHospitaler_identify" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">擅长</span>
					<el-input :value="viewHospitaler_special" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建人</span>
					<el-input :value="viewHospitaler_creater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建时间</span>
					<el-input :value="viewHospitaler_creatDate" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改人</span>
					<el-input :value="viewHospitaler_updater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改时间</span>
					<el-input :value="viewHospitaler_updateDate" disabled></el-input>
				</div>
			</div>
		</Popup>
		<!-- 查看医院管理者弹出框 end -->
		
		<!-- 修改医院管理者弹出框 -->
		<Popup
			v-model="updateHospitaler_popup_display"
			title="更新医院管理者"
			@confirmClick="handleUpdateHospitalerPopupConfirmClick"
		>
			<div v-loading="update_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>账号</span>
					<el-input :value="updateHospitaler_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
					<el-input v-model="updateHospitaler_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateHospitalerName_tip"><i class="b_icon"></i>请输入姓名</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
					<el-input v-model="updateHospitaler_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateHospitalerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>擅长</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="updateHospitaler_special">
							<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateHospitalerSpecial_tip"><i class="b_icon"></i>至少勾选一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属医院</span>
					<VDistpicker :province="updateHospitaler_addr.provinceName" :city="updateHospitaler_addr.cityName" :area="updateHospitaler_addr.areaName" @province="handleUpdateHospitalerAddrProvinceSelect" @city="handleUpdateHospitalerAddrCitySelect" @area="handleUpdateHospitalerAddrAreaSelect"></VDistpicker>
					<div class="base_tip"><template v-if="updateHospitalerAddr_tip"><i class="b_icon"></i>请选择区域</template></div>
					<el-select v-model="updateHospitaler_firm" placeholder="请先选择区域" style="width: 200px;">
						<el-option v-for="(v, i) in updateHospitaler_firms" :key="i" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateHospitalerFirm_tip"><i class="b_icon"></i>请选择所属医院</template></div>
			</div>
		</Popup>
		<!-- 修改医院管理者弹出框 end -->
		
		<!-- 重置密码弹出框 -->
		<reset-password 
			v-model="resetPassword_display"
			:phone="resetPassword_phone"
			:code="resetPassword_code"
			:oid="resetPassword_oid"
			@success="handleResetPasswordSuccess"
		></reset-password>
		<!-- 重置密码弹出框弹出框 end -->
	</div>
</template>

<script>
	import AreaChoise from '../components/area_choise.vue';
	import Api from '../../../../api/index.js';
	import BaseMethods from '../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	import ResetPassword from './components/reset_password.vue';
	
	export default {
		data () {
			return {
				loading: false,
				tableData: [],
				
				currentPage: 1,
				total: 0,
				
				hospitaler_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				hospitaler_name: '',
				hospitaler_phone: '',
				hospitaler_firm: '',
				hospitaler_creater: '',
				hospitaler_startTime: '',
				hospitaler_endTime: '',
				
				add_loading: false,
				addHospitaler_popup_display: false,
				addHospitaler_name: '',
				addHospitaler_phone: '',
				addHospitaler_special: [],
				addHospitaler_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				addHospitaler_firms: [],
				addHospitaler_firm: '',
				addHospitalerName_tip: false,
				addHospitalerPhone_tip: false,
				addHospitalerSpecial_tip: false,
				addHospitalerAddr_tip: false,
				addHospitalerFirm_tip: false,
				
				viewHospitaler_popup_display: false,
				viewHospitaler_data: {},
				viewHospitaler_name: '',
				viewHospitaler_code: '',
				viewHospitaler_phone: '',
				viewHospitaler_firm: '',
				viewHospitaler_identify: '医生',
				viewHospitaler_special: '',
				viewHospitaler_creater: '',
				viewHospitaler_creatDate: '',
				viewHospitaler_updater: '',
				viewHospitaler_updateDate: '',
				
				update_loading: false,
				updateHospitaler_popup_display: false,
				updateHospitaler_id: '',
				updateHospitaler_code: '',
				updateHospitaler_name: '',
				updateHospitaler_phone: '',
				updateHospitaler_special: [],
				updateHospitaler_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				updateHospitaler_firms: [],
				updateHospitaler_firm: '',
				updateHospitalerName_tip: false,
				updateHospitalerPhone_tip: false,
				updateHospitalerSpecial_tip: false,
				updateHospitalerAddr_tip: false,
				updateHospitalerFirm_tip: false,
				
				resetPassword_display: false,
				resetPassword_phone: '',
				resetPassword_code: '',
				resetPassword_oid: ''
			}
		},
		computed: {
			...mapState([
				'authInfo', 
				'allDisease'
			])
		},
		mounted () {
			this.getUserList();
		},
		methods: {
			/************************ @Ajax *******************************/
			// 请求数据
			getUserList () {
				const that = this;
				that.loading = true;
				var _requestData = {
					creater: that.hospitaler_creater,
					endTime: that.hospitaler_endTime,
					limit: 10,
					pageNum: that.currentPage,
					startTime: that.hospitaler_startTime,
					uareaName: that.hospitaler_addr.areaName,
					ucityName: that.hospitaler_addr.cityName,
					ucode: null,
					udiseasesId: null,
					uenterpriseName: that.hospitaler_firm,
					ufinderCategory: 3,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: that.hospitaler_phone,
					uprovinceName: that.hospitaler_addr.provinceName,
					username: that.hospitaler_name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 1
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							that.tableData.push({
								id: res.data.data.data[i].uid,
								name: res.data.data.data[i].name || '',
								code: res.data.data.data[i].ucode || '',
								phone: res.data.data.data[i].phone || '',
								firmId: res.data.data.data[i].uenterpriseId || '',
								firmName: res.data.data.data[i].uenterpriseName || '',
								special: res.data.data.data[i].uexpert || '',
								creater: res.data.data.data[i].creater || '',
								creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '',
								provinceName: res.data.data.data[i].uprovinceName || '',
								provinceCode: res.data.data.data[i].uprovinceCode || '',
								cityName: res.data.data.data[i].ucityName || '',
								cityCode: res.data.data.data[i].ucityCode || '',
								areaName: res.data.data.data[i].uareaName || '',
								areaCode: res.data.data.data[i].uareaCode || '',
								updater: res.data.data.data[i].updater || '',
								updateDate: res.data.data.data[i].updateTime ? res.data.data.data[i].updateTime.split("T")[0] : ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除用户
			deleteUser (uid, oid) {
				const that = this;
				that.loading = true;
				var _requestData = {
					uCategory: 1,
					uId: uid,
					uenterpriseId: oid
				};
				Api.deleteUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.currentPage = 1;
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			/************************ @Events *******************************/
			// 选择城市
			handleAreaChoiseSelect (data) {
				if (data.sign == "P") {
					this.hospitaler_addr.provinceCode = data.key.slice(0, 3);
					this.hospitaler_addr.provinceName = data.label;
					this.hospitaler_addr.cityCode = '';
					this.hospitaler_addr.cityName = '';
					this.hospitaler_addr.areaCode = '';
					this.hospitaler_addr.areaName = '';
					this.currentPage = 1;
					this.getUserList();
				} else if (data.sign == "C") {
					this.hospitaler_addr.provinceCode = data.parentKey.slice(0, 3);
					this.hospitaler_addr.provinceName = data.parentLabel;
					this.hospitaler_addr.cityCode = data.key + '000000';
					this.hospitaler_addr.cityName = data.label;
					this.hospitaler_addr.areaCode = '';
					this.hospitaler_addr.areaName = '';
					this.currentPage = 1;
					this.getUserList();
				} else if (data.sign == "A") {
					this.hospitaler_addr.provinceCode = data.grandKey.slice(0, 3);
					this.hospitaler_addr.provinceName = data.grandLabel;
					this.hospitaler_addr.cityCode = data.parentKey + '000000';
					this.hospitaler_addr.cityName = data.parentLabel;
					this.hospitaler_addr.areaCode = data.key + '000000';
					this.hospitaler_addr.areaName = data.label;
					this.currentPage = 1;
					this.getUserList();
				} else {
					this.hospitaler_addr.provinceCode = '';
					this.hospitaler_addr.provinceName = '';
					this.hospitaler_addr.cityCode = '';
					this.hospitaler_addr.cityName = '';
					this.hospitaler_addr.areaCode = '';
					this.hospitaler_addr.areaName = '';
					this.currentPage = 1;
					this.getUserList();
				}
			},
			// 切换查询时间
			handleSearchStartTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick () {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getUserList();
			},
			// 点击页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getUserList();
				}
			},
			// 导出Excel数据
			exportExcel () {
				const that = this;
				that.loading = true;
				var _requestData = {
					creater: that.hospitaler_creater,
					endTime: that.hospitaler_endTime,
					limit: 10000,
					pageNum: 1,
					startTime: that.hospitaler_startTime,
					uareaName: that.hospitaler_addr.areaName,
					ucityName: that.hospitaler_addr.cityName,
					ucode: null,
					udiseasesId: null,
					uenterpriseName: that.hospitaler_firm,
					ufinderCategory: 3,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: that.hospitaler_phone,
					uprovinceName: that.hospitaler_addr.provinceName,
					username: that.hospitaler_name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 2
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,姓名,账号,手机号,所属医院,创建人,创建时间,\n';
						for (var i = 0;i < res.data.data.data.length;i++) {
							str += `${ i+1 },`
							str += res.data.data.data[i].name || '';
							str += ',';
							str += res.data.data.data[i].ucode || '';
							str += '\t,';
							str += res.data.data.data[i].phone || '';
							str += '\t,';
							str += res.data.data.data[i].uenterpriseName || '';
							str += ',';
							str += res.data.data.data[i].creater || '';
							str += ',';
							str += res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '';
							str += '\t,';
							str += '\n';
							// data.push({
							// 	name: res.data.data.data[i].name || '',
							// 	code: res.data.data.data[i].ucode || '',
							// 	phone: res.data.data.data[i].phone || '',
							// 	firmName: res.data.data.data[i].uenterpriseName || '',
							// 	creater: res.data.data.data[i].creater || '',
							// 	creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : ''
							// });
						}
						BaseMethods.outputExcel(str, '医院管理者');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击新增
			handleAddHospitalerClick () {
				this.add_loading = false;
				this.addHospitaler_name = '';
				this.addHospitaler_phone = '';
				this.addHospitaler_special = [];
				this.addHospitaler_addr = {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				};
				this.addHospitaler_firms = [];
				this.addHospitaler_firm = '';
				this.addHospitalerName_tip = false;
				this.addHospitalerPhone_tip = false;
				this.addHospitalerSpecial_tip = false;
				this.addHospitalerAddr_tip = false;
				this.addHospitalerFirm_tip = false;
				this.addHospitaler_popup_display = true;
			},
			// 新增地址省份选择
			handleAddHospitalerAddrProvinceSelect (data) {
				this.addHospitaler_addr.provinceName = data.code ? data.value : '';
				this.addHospitaler_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 新增地址城市选择
			handleAddHospitalerAddrCitySelect (data) {
				this.addHospitaler_addr.cityName = data.code ? data.value : '';
				this.addHospitaler_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 新增地址区域选择
			handleAddHospitalerAddrAreaSelect (data) {
				const that = this;
				that.addHospitaler_addr.areaName = data.code ? data.value : '';
				that.addHospitaler_addr.areaCode = data.code ? `${ data.code }000000` : '';
				that.add_loading = true;
				var _requestData = {
					uAreaCode: that.addHospitaler_addr.areaCode,
					uCategory: 3,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(_requestData).then((res) => {
					that.add_loading = false;
					if (res.data.success) {
						that.addHospitaler_firms = [];
						res.data.data.forEach((v) => {
							that.addHospitaler_firms.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						that.addHospitaler_firm = that.addHospitaler_firms.length
							? that.addHospitaler_firms[0].id
							: '';
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				});
				
			},
			// 点击新增医院管理者弹框添加按钮
			handleAddHospitalerPopupConfirmClick () {
				const that = this;
				if (!that.addHospitaler_name.trim()) {	// 校验姓名
					that.addHospitalerName_tip = true;
					return false;
				} else {
					that.addHospitalerName_tip = false;
				}
				if (!that.phoneReg.test(that.addHospitaler_phone)) {	// 校验手机号
					that.addHospitalerPhone_tip = true;
					return false;
				} else {
					that.addHospitalerPhone_tip = false;
				}
				if (!that.addHospitaler_special.length) {	// 校验擅长
					that.addHospitalerSpecial_tip = true;
					return false;
				} else {
					that.addHospitalerSpecial_tip = false;
				}
				if (!that.addHospitaler_addr.areaCode) {	// 校验代理区域
					that.addHospitalerAddr_tip = true;
					return false;
				} else {
					that.addHospitalerAddr_tip = false;
				}
				if (!that.addHospitaler_firm) {	// 校验所属企业
					that.addHospitalerFirm_tip = true;
					return false;
				} else {
					that.addHospitalerFirm_tip = false;
				}
				that.loading = true;
				var _requestData = {
					"id": null,
					"openUmBUserVo": {
						"isExamine": null,
						"uareaCode": that.addHospitaler_addr.areaCode,
						"uareaName": that.addHospitaler_addr.areaName,
						"ucategory": 3,
						"ucategorySpecific": null,
						"ucityCode": that.addHospitaler_addr.cityCode,
						"ucityName": that.addHospitaler_addr.cityName,
						"ucode": that.addHospitaler_phone,
						"ucreate": null,
						"ucreateTs": null,
						"uenterpriseId": that.addHospitaler_firm,
						"uexpert": that.addHospitaler_special.join(","),
						"uid": null,
						"ulevel": null,
						"uname": that.addHospitaler_name,
						"unationalityCode": null,
						"unationalityName": null,
						"uphone": that.addHospitaler_phone,
						"uprovinceCode": that.addHospitaler_addr.provinceCode,
						"uprovinceName": that.addHospitaler_addr.provinceName,
						"usex": null
					},
					"openUmWUserVo": {
						"u_r_name": null,
						"uaddressToAreaCode": null,
						"uaddressToAreaName": null,
						"uaddressToCityCode": null,
						"uaddressToCityName": null,
						"uaddressToNationalityCode": null,
						"uaddressToNationalityName": null,
						"uaddressToProvinceCode": null,
						"uaddressToProvinceName": null,
						"uage": null,
						"uareaCode": null,
						"uareaName": null,
						"uattendingDoctor": null,
						"ucityCode": null,
						"ucityName": null,
						"ucode": null,
						"uid": null,
						"uleftCva": null,
						"uleftNeva": null,
						"umemo": null,
						"unationalityCode": null,
						"unationalityName": null,
						"uoverspreadEye": null,
						"uphone": null,
						"uprovinceCode": null,
						"uprovinceName": null,
						"urightCva": null,
						"urightNeva": null,
						"usex": null
					},
					"type": "b",
					"ucode": that.authInfo.ucode
				};
				Api.addUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.addHospitaler_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击查看
			handleViewHospitalerClick (data) {
				this.viewHospitaler_data = data;
				this.viewHospitaler_name = data.name;
				this.viewHospitaler_code = data.code;
				this.viewHospitaler_phone = data.phone,
				this.viewHospitaler_firm = data.firmName;
				this.viewHospitaler_special = this.mapDiseaseToName(data.special);
				this.viewHospitaler_creater = data.creater;
				this.viewHospitaler_creatDate = data.creatDate;
				this.viewHospitaler_updater = data.updater;
				this.viewHospitaler_updateDate = data.updateDate;
				this.viewHospitaler_popup_display = true;
			},
			// 点击修改
			handleUpdateHospitalerClick () {
				const that = this;
				var data = this.viewHospitaler_data;
				this.viewHospitaler_popup_display = false;
				this.updateHospitaler_id = data.id;
				this.updateHospitaler_code = data.code;
				this.updateHospitaler_name = data.name;
				this.updateHospitaler_phone = data.phone;
				this.updateHospitaler_special = [];
				for (var i = 0;i < data.special.split(",").length;i++) {
					this.updateHospitaler_special.push(parseInt(data.special.split(",")[i]));
				}
				this.updateHospitaler_addr = {
					provinceName: data.provinceName,
					provinceCode: data.provinceCode,
					cityName: data.cityName,
					cityCode: data.cityCode,
					areaName: data.areaName,
					areaCode: data.areaCode
				};
				this.updateHospitaler_firms = [];
				this.updateHospitaler_firm = '';
				this.updateHospitalerName_tip = false;
				this.updateHospitalerPhone_tip = false;
				this.updateHospitalerSpecial_tip = false;
				this.updateHospitalerAddr_tip = false;
				this.updateHospitalerFirm_tip = false;
				that.loading = true;
				var _requestData = {
					uAreaCode: that.updateHospitaler_addr.areaCode,
					uCategory: 3,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateHospitaler_firms = [];
						var _already = false;
						res.data.data.forEach((v) => {
							data.firmId == v.uenterpriseId && (_already = true);
							that.updateHospitaler_firms.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						_already
							? (that.updateHospitaler_firm = data.firmId)
							: (that.updateHospitaler_firm = that.updateHospitaler_firms.length
								? that.updateHospitaler_firms[0].id
								: ''
							);
						that.updateHospitaler_popup_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改代理用户地址省份选择
			handleUpdateHospitalerAddrProvinceSelect (data) {
				this.updateHospitaler_addr.provinceName = data.code ? data.value : '';
				this.updateHospitaler_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 修改代理用户地址城市选择
			handleUpdateHospitalerAddrCitySelect (data) {
				this.updateHospitaler_addr.cityName = data.code ? data.value : '';
				this.updateHospitaler_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 修改代理用户地址区域选择
			handleUpdateHospitalerAddrAreaSelect (data) {
				const that = this;
				that.updateHospitaler_addr.areaName = data.code ? data.value : '';
				that.updateHospitaler_addr.areaCode = data.code ? `${ data.code }000000` : '';
				that.update_loading = true;
				var _requestData = {
					uAreaCode: that.updateHospitaler_addr.areaCode,
					uCategory: 3,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(_requestData).then((res) => {
					that.update_loading = false;
					if (res.data.success) {
						that.updateHospitaler_firms = [];
						res.data.data.forEach((v) => {
							that.updateHospitaler_firms.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						that.updateHospitaler_firm = that.updateHospitaler_firms.length
							? that.updateHospitaler_firms[0].id
							: '';
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击修改弹框确定按钮
			handleUpdateHospitalerPopupConfirmClick () {
				const that = this;
				if (!that.updateHospitaler_name.trim()) {
					that.updateHospitalerName_tip = true;
					return false;
				} else {
					that.updateHospitalerName_tip = false;
				}
				if (!that.phoneReg.test(that.updateHospitaler_phone)) {
					that.updateHospitalerPhone_tip = true;
					return false;
				} else {
					that.updateHospitalerPhone_tip = false;
				}
				if (!that.updateHospitaler_special.length) {
					that.updateHospitalerSpecial_tip = true;
					return false;
				} else {
					that.updateHospitalerSpecial_tip = false;
				}
				if (!that.updateHospitaler_addr.areaCode) {
					that.updateHospitalerAddr_tip = true;
					return false;
				} else {
					that.updateHospitalerAddr_tip = false;
				}
				if (!that.updateHospitaler_firm) {
					that.updateHospitalerFirm_tip = true;
					return false;
				} else {
					that.updateHospitalerFirm_tip = false;
				}
				that.loading = true;
				var _requestData = {
					"age": null,
					"name": that.updateHospitaler_name,
					"phone": that.updateHospitaler_phone,
					"uareaCode": that.updateHospitaler_addr.areaCode,
					"uareaName": that.updateHospitaler_addr.areaName,
					"uattendingDoctor": null,
					"ucategory": 1,
					"ucityCode": that.updateHospitaler_addr.cityCode,
					"ucityName": that.updateHospitaler_addr.cityName,
					"ucode": that.updateHospitaler_code,
					"uenterpriseId": that.updateHospitaler_firm,
					"uexpert": that.updateHospitaler_special.join(","),
					"uid": that.updateHospitaler_id,
					"unationalityCode": null,
					"unationalityName": null,
					"uprovinceCode": that.updateHospitaler_addr.provinceCode,
					"uprovinceName": that.updateHospitaler_addr.provinceName
				};
				Api.updateUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateHospitaler_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击重置密码
			handleResetPasswordClick (data) {
				this.resetPassword_phone = data.phone;
				this.resetPassword_code = data.code;
				this.resetPassword_oid = data.firmId;
				this.resetPassword_display = true;
			},
			// 重置密码成功
			handleResetPasswordSuccess (msg) {
				this.$message.success(msg);
				this.resetPassword_display = false;
			},
			// 点击删除
			handleDeleteClick(msg) {
				const that = this;
				that.$confirm(
					'此操作将删除该用户，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteUser(msg.id, msg.firmId);
					}
				).catch(
					() => {}
				);
			},
			
			/************************ @Function *******************************/
			// 把病理类型转换成名称
			mapDiseaseToName (diseaseStr) {
				var _diseaseList = diseaseStr.split(","),
					result = [];
				for (var i = 0;i < _diseaseList.length;i++) {
					for (var w = 0;w < this.allDisease.length;w++) {
						if (_diseaseList[i] == this.allDisease[w].id) {
							result.push(this.allDisease[w].name);
						}
					}
				}
				return result.join("，");
			},
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.hospitaler_startTime && this.hospitaler_endTime) {
					var startTime = new Date(this.hospitaler_startTime).getTime(),
						endTime = new Date(this.hospitaler_endTime).getTime();
					if (endTime < startTime) {
						this.hospitaler_endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		},
		components: {
			AreaChoise,
			ResetPassword
		}
	}
</script>

<style scoped>
</style>
